import * as constants from '../constants';
import { RouterAction } from 'react-router-redux';

export interface AuthRequest {
  type: constants.AUTH_REQUEST;
  provider: string;
}

export const authRequest = (provider: string): AuthRequest => {
  return {
    provider,
    type: constants.AUTH_REQUEST,
  };
};
export interface Auth {
  expertId: string;
  authToken: string;
  provider: string;
  queues: string[];
  name: string;
}
export interface AuthSuccess extends Auth {
  type: constants.AUTH_SUCCESS;
}

export interface AuthRenewSuccess extends Auth {
  type: constants.AUTH_RENEW_SUCCESS;
}

export const authSuccess = (expertId: string,
                            authToken: string,
                            provider: string,
                            queues: string[],
                            name: string): AuthSuccess => {
  return {
    expertId,
    authToken,
    provider,
    queues,
    name,
    type: constants.AUTH_SUCCESS,
  };
};

export const authRenewSuccess = (expertId: string,
                                 authToken: string,
                                 provider: string,
                                 queues: string[],
                                 name: string): AuthRenewSuccess => {
  return {
    expertId,
    authToken,
    provider,
    queues,
    name,
    type: constants.AUTH_RENEW_SUCCESS,
  };
};


export interface AuthPopupClose {
  type: constants.AUTH_POPUP_CLOSE;
}

export const authPopupClose = (): AuthPopupClose => {
  return {
    type: constants.AUTH_POPUP_CLOSE,
  };
};


export interface AuthPopupCloseSuccess {
  type: constants.AUTH_POPUP_CLOSE_SUCCESS;
}

export const authPopupCloseSuccess = (): AuthPopupCloseSuccess => {
  return {
    type: constants.AUTH_POPUP_CLOSE_SUCCESS,
  };
};


export interface LogoutRequest {
  type: constants.LOGOUT_REQUEST;
}

export const logoutRequest = (): LogoutRequest => {
  return {
    type: constants.LOGOUT_REQUEST,
  };
};
export interface LogoutSuccess {
  type: constants.LOGOUT_SUCCESS;
}

export const logoutSuccess = (): LogoutSuccess => {
  return {
    type: constants.LOGOUT_SUCCESS,
  };
};

export interface LoginWithToken {
  type: constants.LOGIN_WITH_TOKEN;
  token: string;
  expertId: string;
}

export interface LoginWithQueryParam {
  type: constants.LOGIN_WITH_QUERY_PARAM;
}

export const loginWithToken = (token: string, expertId: string): LoginWithToken => ({
  token,
  expertId,
  type: constants.LOGIN_WITH_TOKEN,
});

export const loginWithQueryParam = (): LoginWithQueryParam => ({
  type: constants.LOGIN_WITH_QUERY_PARAM,
});

export type AuthAction = AuthSuccess
  | AuthRequest
  | AuthPopupClose
  | AuthPopupCloseSuccess
  | RouterAction
  | LogoutRequest
  | LogoutSuccess
  | AuthRenewSuccess
  | LoginWithToken
  | LoginWithQueryParam;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/auth.ts